import { storyblokEditable } from '@storyblok/react';
import { FC } from 'react';
import { SeoAccordeonStoryblok } from 'storyblok-types';
import { Body, HeadLine, Title } from 'atoms/Typography/Typography';
import { AccordionWithImage } from 'molecules/Accordion';
import { ReactMarkdown } from 'molecules/Markdown';
import { isValidDate, renderRichText } from 'modules/stroyblok/services';
import styles from './SeoAccordion.module.css';

interface IBlok extends SeoAccordeonStoryblok {
  backgroundColor?: { color: string };
}

export const SeoAccordion: FC<{
  blok?: IBlok;
}> = ({ blok }) => {
  const isDateValid = isValidDate(blok?.startDate, blok?.expirationDate);
  const isHidden = !blok || !isDateValid || blok.disableForLocale;

  return isHidden ? null : (
    <div
      className={styles.root}
      style={{ backgroundColor: blok.backgroundColor?.color }}
    >
      {!!blok.title && (
        <HeadLine
          type="sm"
          tag="h1"
          color="purple"
          weight="bold"
          className={styles.title}
        >
          {blok.title}
        </HeadLine>
      )}
      <div className={styles.list} {...storyblokEditable(blok)}>
        {blok?.entries?.map(
          ({ _uid, headline, image, jumpMark, textarea, isExtended }) => (
            <AccordionWithImage
              key={_uid}
              id={jumpMark}
              summaryContent={headline}
              defaultExpanded={isExtended}
              src={image?.filename}
              alt={image?.alt}
              invertArrow
              classes={{
                details: styles.listElementWrapper,
              }}
            >
              <ReactMarkdown
                text={renderRichText(textarea) || ''}
                components={{
                  blockquote: ({ children }) => (
                    <blockquote className={styles.blockquote}>
                      {children}
                    </blockquote>
                  ),
                  h3: ({ children }) => (
                    <Title type="md" tag="h3" className={styles.titleInText}>
                      {children}
                    </Title>
                  ),
                  p: ({ children }) => {
                    return (
                      <Body type="md" className={styles.text}>
                        {children}
                      </Body>
                    );
                  },
                }}
              />
            </AccordionWithImage>
          ),
        )}
      </div>
    </div>
  );
};
